import { Remirror, useRemirror } from '@remirror/react';

const RichTextRenderer = (props) => {
    const { content, extensions = [], className } = props;
    const { manager, state } = useRemirror({
        extensions: () => extensions,
        stringHandler: 'html',
        content: content
    });

    return (
        <div className={className}>
            <Remirror editable={false} manager={manager} state={state} onChange={() => {}} />
        </div>
    );
};

export default RichTextRenderer;
